import { render, staticRenderFns } from "./weChatRedStatistical.vue?vue&type=template&id=4239926c&scoped=true&"
import script from "./weChatRedStatistical.vue?vue&type=script&lang=js&"
export * from "./weChatRedStatistical.vue?vue&type=script&lang=js&"
import style0 from "./weChatRedStatistical.vue?vue&type=style&index=0&id=4239926c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239926c",
  null
  
)

component.options.__file = "weChatRedStatistical.vue"
export default component.exports